import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'

import NotFoundResource from '@/components/router/not-found-resource'
import RouteSheet from '@/components/sheets/route-sheet'

const params = z.object({
  policyUuid: z.string(),
})

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/insured/policies/$policyUuid',
)({
  component: RouteComponent,
  params,
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.policy.resource-type')}
        backTo={t('resource-not-found.not-found.policy.back-to-policies-list')}
        backToLink={closeLink}
      />
    )
  },
})

const closeLink = linkOptions({
  from: Route.fullPath,
  to: '..',
})

function RouteComponent() {
  return <RouteSheet closeLink={closeLink} />
}
